const ShareUploadIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M10 12.5V3.33333M10 3.33333L6.66667 6.66667M10 3.33333L13.3333 6.66667M4.16667 12.5V15.8333C4.16667 16.7538 4.91286 17.5 5.83333 17.5H14.1667C15.0871 17.5 15.8333 16.7538 15.8333 15.8333V12.5"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShareUploadIcon;
